import React from "react";

export function AderenciaBadge({ value, testid }) {
  const v = value ?? 0;
  let cls = "bg-slate-100 text-slate-600 border-slate-200";
  if (v >= 80) cls = "bg-emerald-50 text-emerald-700 border-emerald-200";
  else if (v >= 50) cls = "bg-sky-50 text-sky-700 border-sky-200";
  return (
    <span
      data-testid={testid || "opportunity-card-match-badge"}
      className={`inline-flex items-center gap-1 rounded-full border px-2.5 py-1 text-xs font-bold ${cls}`}
      title="Índice de aderência (apenas para priorização, não garante participação)"
    >
      <span className="h-1.5 w-1.5 rounded-full bg-current" />
      {v}% aderência
    </span>
  );
}

const STAGE_STYLE = {
  NOVA: "bg-sky-50 text-sky-700 border-sky-200",
  ANALISAR: "bg-blue-50 text-blue-700 border-blue-200",
  FAVORITA: "bg-violet-50 text-violet-700 border-violet-200",
  "DOCUMENTAÇÃO": "bg-indigo-50 text-indigo-700 border-indigo-200",
  "COTAÇÃO": "bg-teal-50 text-teal-700 border-teal-200",
  "PRECIFICAÇÃO": "bg-teal-50 text-teal-700 border-teal-200",
  "PROPOSTA EM PREPARAÇÃO": "bg-amber-50 text-amber-700 border-amber-200",
  "PROPOSTA PRONTA": "bg-amber-50 text-amber-700 border-amber-200",
  "PROPOSTA ENVIADA": "bg-cyan-50 text-cyan-700 border-cyan-200",
  "EM DISPUTA": "bg-orange-50 text-orange-700 border-orange-200",
  "1º COLOCADO": "bg-lime-50 text-lime-700 border-lime-200",
  "EM HABILITAÇÃO": "bg-orange-50 text-orange-700 border-orange-200",
  "DECLARADO VENCEDOR": "bg-emerald-50 text-emerald-700 border-emerald-200",
  "ADJUDICADO": "bg-emerald-50 text-emerald-700 border-emerald-200",
  "HOMOLOGADO": "bg-emerald-100 text-emerald-800 border-emerald-300",
  "CONTRATO/EMPENHO": "bg-green-100 text-green-800 border-green-300",
  GANHA: "bg-emerald-50 text-emerald-700 border-emerald-200",
  PERDIDA: "bg-rose-50 text-rose-700 border-rose-200",
  "DESCLASSIFICADA": "bg-rose-50 text-rose-700 border-rose-200",
  "INABILITADA": "bg-rose-50 text-rose-700 border-rose-200",
  CANCELADA: "bg-slate-100 text-slate-600 border-slate-300",
  "CONCLUÍDA": "bg-slate-100 text-slate-600 border-slate-300",
};

export function StageBadge({ stage, testid }) {
  const cls = STAGE_STYLE[stage] || "bg-slate-100 text-slate-600 border-slate-200";
  return (
    <span data-testid={testid} className={`inline-flex items-center rounded-md border px-2 py-0.5 text-[11px] font-semibold uppercase tracking-wide ${cls}`}>
      {stage}
    </span>
  );
}

export function Chip({ children, className = "" }) {
  return (
    <span className={`inline-flex items-center rounded-md bg-slate-100 px-2 py-0.5 text-[11px] font-medium text-slate-600 ${className}`}>
      {children}
    </span>
  );
}

const SCOUT_CLASS_STYLE = {
  prioritaria: ["🔥 Prioritária", "bg-rose-50 text-rose-700 border-rose-200"],
  boa: ["🟢 Boa oportunidade", "bg-emerald-50 text-emerald-700 border-emerald-200"],
  analisar: ["🟡 Analisar", "bg-amber-50 text-amber-700 border-amber-200"],
  ressalvas: ["⚠️ Com ressalvas", "bg-orange-50 text-orange-700 border-orange-200"],
  baixa: ["🔴 Baixa aderência", "bg-slate-100 text-slate-500 border-slate-200"],
};
const STATUS_OP_STYLE = {
  aberta: ["🟢 Aberta", "bg-emerald-50 text-emerald-700"],
  julgamento: ["🟡 Em julgamento", "bg-amber-50 text-amber-700"],
  encerrada: ["🔵 Encerrada", "bg-sky-50 text-sky-700"],
  nao_identificado: ["⚪ Status ND", "bg-slate-100 text-slate-500"],
};

export function ScoutBadge({ scout, testid }) {
  if (!scout) return null;
  const [lbl, cls] = SCOUT_CLASS_STYLE[scout.classificacao] || SCOUT_CLASS_STYLE.analisar;
  return (
    <span data-testid={testid || "scout-class-badge"}
      className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[11px] font-bold ${cls}`}
      title="Classificação PRO INVICTA SCOUT (priorização interna, não garante participação)">
      {lbl} · {scout.indice}
    </span>
  );
}

export function StatusOpBadge({ status, testid }) {
  if (!status) return null;
  const [lbl, cls] = STATUS_OP_STYLE[status] || STATUS_OP_STYLE.nao_identificado;
  return <span data-testid={testid} className={`inline-flex items-center rounded-md px-2 py-0.5 text-[11px] font-semibold ${cls}`}>{lbl}</span>;
}

const COMPLIANCE_STYLE = {
  verde: ["🟢 Compliance OK", "bg-emerald-50 text-emerald-700 border-emerald-200"],
  amarelo: ["🟡 Compliance c/ ressalvas", "bg-amber-50 text-amber-700 border-amber-200"],
  vermelho: ["🔴 Compliance crítico", "bg-rose-50 text-rose-700 border-rose-200"],
  cinza: ["⚪ Compliance ND", "bg-slate-100 text-slate-500 border-slate-200"],
};

export function ComplianceBadge({ status, testid }) {
  if (!status) return null;
  const [lbl, cls] = COMPLIANCE_STYLE[status] || COMPLIANCE_STYLE.cinza;
  return (
    <span data-testid={testid || "compliance-badge"}
      className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[11px] font-bold ${cls}`}
      title="Agente de Compliance operacional (entrega/logística/venda à ordem) — análise interna, confirme no edital">
      {lbl}
    </span>
  );
}
